module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-input-email",
    class: [_vm.message.type !== '' ? 'is-' + _vm.message.type : '']
  }, [_c('div', {
    staticClass: "u-uppercase t-fsize--xs u-color--white t-ffamily--simplon t-fweight--bold"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-input-email__wrapper__input js-input-email-container u-relative u-marg-t-xs u-flex u-flex-jc--space-between",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "c-input-email__wrapper__input-element js-input-email u-fit-w u-bg--transparent u-color--white",
    attrs: {
      "type": "email",
      "id": _vm.labelFor,
      "placeholder": "name@example.com"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "keydown": [function($event) {
        _vm._hideErrorMessage()
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm._submitForm()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-input-email__wrapper__input-arrow u-flex u-flex-ai--center u-flex-jc--center u-cursor-pointer",
    on: {
      "click": function($event) {
        _vm._submitForm()
      }
    }
  }, [(!_vm.isSending) ? _c('app-icon', {
    staticClass: "c-input-email__wrapper__input-arrow__svg u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-arrow--right.png"
    }
  }) : _c('app-icon', {
    staticClass: "c-input-email__wrapper__input-arrow__svg-loading u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-loader"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "c-input-email__message u-marg-t-xxs u-flex u-flex-jc--space-between u-flex-ai--center",
    class: [_vm.message.active ? 'is-shown' : 'is-hidden']
  }, [(_vm.message.type === 'success') ? _c('app-icon', {
    staticClass: "u-fill--white u-stroke--white",
    attrs: {
      "name": "icon-check",
      "width": "15"
    }
  }) : (_vm.message.type === 'error') ? _c('app-icon', {
    staticClass: "u-fill--brand-error u-stroke--brand-error",
    attrs: {
      "name": "icon-cross",
      "width": "12"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "c-input-email__message__text t-fsize--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.message.content)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-734dc7fe"}!./src/scripts/components/app-input-email/template.html
// module id = 474
// module chunks = 0